export default __webpack_public_path__ + "static/media/skeleton2.2afe2366.png";